module.exports = __webpack_public_path__ + "static/europe-75977219ae220b2bb786513e150f0791.svg";